import ChevronLeft from 'components/Icons/ChevronLeft';
import SmallCross from 'components/Icons/SmallCross';
import collapseIcon from 'images/icons/collapse-16.svg';
import expandIcon from 'images/icons/expand-16.svg';
import noop from 'lodash/noop';
import React from 'react';

interface Props {
  id?: string;
  title?: string;
  onCancelClick?: (evt: React.MouseEvent) => void;
  backArrow?: boolean;
  onBackArrowClick?: () => void;
  showExpand?: boolean;
  onToggleExpand?: () => void;
  expanded?: boolean;
}
const OverlayHeader: React.FC<Props> = (props) => {
  const {
    id,
    backArrow,
    onBackArrowClick,
    title,
    onCancelClick,
    showExpand,
    onToggleExpand,
    expanded,
    children,
  } = props;

  return (
    <div
      id={id}
      className="overlay-header hs3 shrink-0 bgd-primary row items-center justify-between pl4 pr3"
      style={{ zIndex: 3 }}
    >
      {backArrow ? (
        <div
          id={`${id}-back-arrow`}
          className="wrem-1p5 hrem-1p5 flex-center fill-white mr3 cursor-pointer"
          onClick={onBackArrowClick}
        >
          <ChevronLeft width="9px" height="16px" />
        </div>
      ) : null}
      <div
        id={`${id}-title`}
        className="color-gray-1 font-size-4 medium truncate"
      >
        {title}
      </div>
      <div className="row grow-1 px3">{children}</div>
      {showExpand ? (
        <div
          className="cursor-pointer flex-center mr2"
          onClick={onToggleExpand}
        >
          {expanded ? (
            <img src={collapseIcon} alt="collapse overlay" />
          ) : (
            <img src={expandIcon} alt="expand overlay" />
          )}
        </div>
      ) : null}
      <span
        id={`${id}-close-x`}
        className="ws1 hs1 flex-center line-height-1 font-size-9 cursor-pointer color-gray-1"
        onClick={onCancelClick}
      >
        <SmallCross width="8px" height="8px" />
      </span>
    </div>
  );
};

OverlayHeader.defaultProps = {
  backArrow: false,
  onBackArrowClick: noop,
  showExpand: false,
  onToggleExpand: noop,
  expanded: false,
};

export default OverlayHeader;
